import React from 'react';
function SearchCategoryLayout(props) {
  var categoryContent = props.categoryContent,
    resultsContent = props.resultsContent;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "name"
  }, categoryContent), /*#__PURE__*/React.createElement("div", {
    className: "results"
  }, resultsContent));
}
SearchCategoryLayout.handledProps = ["categoryContent", "resultsContent"];
export default SearchCategoryLayout;